export const routeSelector = state => state.route;

export const currentRouteSelector = state => routeSelector(state).current;
